"use client"

import { toImageSrc } from "@/lib/utils"
import type { CompanyListItemProps } from "@/types/types"
import Image from "next/image"
import Link from "next/link"
import "./companyList.css"

export const CompanyListItem = ({ company, className = "", style }: CompanyListItemProps) => {
  const imageUrl = toImageSrc(company.image)
  const imageWidth = company.width || 226
  const imageHeight = company.height || 226

  const hasCustomPadding =
    company.paddingTop !== undefined ||
    company.paddingRight !== undefined ||
    company.paddingBottom !== undefined ||
    company.paddingLeft !== undefined

  const containerClass = `company-list-item flex flex-col items-center gap-0 ${hasCustomPadding ? "" : "sm:py-3"
    } cursor-pointer sm:rounded-lg duration-500 hover:brightness-110 max-w-full ${className}`

  const containerStyle = {
    ...style,
    ...(company.paddingTop !== undefined && { paddingTop: `${company.paddingTop}px` }),
    ...(company.paddingRight !== undefined && { paddingRight: `${company.paddingRight}px` }),
    ...(company.paddingBottom !== undefined && { paddingBottom: `${company.paddingBottom}px` }),
    ...(company.paddingLeft !== undefined && { paddingLeft: `${company.paddingLeft}px` }),
  }

  const content = (
    <>
      <div
        className="relative w-full sm:max-w-[226px] max-w-full"
        style={{
          ...(company.width && { width: `${company.width}px`, minWidth: `${company.width}px` }),
          ...(company.height && { height: `${company.height}px`, minHeight: `${company.height}px` }),
        }}
      >
        <Image
          src={imageUrl}
          alt={company.companyName || "Company logo"}
          width={imageWidth}
          height={imageHeight}
          className="object-contain w-full h-auto"
          sizes="(max-width: 639px) 50vw, 226px"
        />
      </div>
      {company.companyName && company.companyName.trim() && (
        <p className="text-center text-base font-semibold leading-[1.55rem] max-w-[226px] text-[#333333]">
          {company.companyName}
        </p>
      )}
    </>
  )

  const link = (company as { link?: string }).link

  if (link) {
    return (
      <Link href={link} target="_blank" rel="noopener noreferrer" className={containerClass} style={containerStyle}>
        {content}
      </Link>
    )
  }

  return (
    <div className={containerClass} style={containerStyle}>
      {content}
    </div>
  )
}
